<template>
    <div class="auth-presentation-card">
        <!-- Badge & Évolution Dahub -> Uska avec les vrais logos -->
        <div class="brand-evolution mb-4">
            <div class="dahub-brand-wrapper">
                <img src="/images/logo_dahub_official.png" alt="Dahub" class="dahub-logo-img" />
            </div>
            <span class="transition-badge">devient (enfin)</span>
            <div class="uska-brand-wrapper">
                <img src="/images/logo_uska_horizontal.svg" alt="Uska" class="uska-logo-img" />
            </div>
        </div>

        <h2 class="auth-promo-title mb-4">
            Et s'accompagne d'un nouvel espace pro !
        </h2>

        <!-- Grille des deux arguments rassurants -->
        <div class="row g-3 presentation-features mb-4">
            <div class="col-12 col-md-6">
                <div class="feature-box h-100">
                    <div class="feature-icon-wrapper shield-icon">
                        <v-icon color="#f97316" small>verified_user</v-icon>
                    </div>
                    <h3 class="feature-heading">Rien ne change pour vous</h3>
                    <p class="feature-description mb-0">
                        Vos accès, vos données, vos campagnes et vos habitudes restent identiques. Vous retrouvez toutes vos fonctionnalités comme avant.
                    </p>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="feature-box h-100">
                    <div class="feature-icon-wrapper star-icon">
                        <v-icon color="#f97316" small>auto_awesome</v-icon>
                    </div>
                    <h3 class="feature-heading">Encore plus simple pour vos pros</h3>
                    <p class="feature-description mb-0">
                        Un parcours simplifié, une interface plus claire et enrichie de services toujours plus utiles pour vos partenaires.
                    </p>
                </div>
            </div>
        </div>

        <!-- Bloc FAQ -->
        <div class="faq-cta-box text-center">
            <p class="faq-cta-text mb-2">Envie d’en savoir plus ? Découvrez la FAQ complète</p>
            <a
                href="https://intercom.help/dahub/fr/articles/16818945-foire-aux-questions-uska"
                target="_blank"
                class="faq-link-btn"
            >
                <v-icon x-small color="#ea580c" class="mr-1">open_in_new</v-icon>
                <span>Consulter la FAQ</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuthPresentation"
}
</script>